<script setup lang="ts">
defineProps<{
  name: string;
}>();
</script>
<template>
  <div class="sidebar-name">
    {{ name }}
  </div>
</template>
<style scoped lang="scss">
.sidebar-name {
  @include font-h3-bold;
  margin-top: var(--Spacing-spacing-5);
}
</style>
